import { useEffect, useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const VerifyEmail = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading"); // loading | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setStatus("error");
      setMessage("Kein Bestätigungstoken angegeben.");
      return;
    }
    (async () => {
      try {
        const resp = await axios.get(`${API}/auth/verify-email`, { params: { token } });
        setStatus("success");
        setMessage(resp.data.message || "E-Mail erfolgreich bestätigt!");
      } catch (e) {
        setStatus("error");
        setMessage(e.response?.data?.detail || "Ungültiger oder abgelaufener Verifizierungslink.");
      }
    })();
  }, [params]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#2835F7] via-[#1a25c9] to-[#0d1570] flex items-center justify-center px-4" data-testid="verify-email-page">
      <div className="bg-white/10 backdrop-blur-xl rounded-3xl p-10 shadow-2xl border border-white/20 max-w-md w-full text-center text-white">
        {status === "loading" && (
          <>
            <Loader2 className="w-16 h-16 mx-auto mb-4 animate-spin text-white/80" />
            <h1 className="text-2xl font-bold">E-Mail wird bestätigt...</h1>
          </>
        )}
        {status === "success" && (
          <>
            <CheckCircle2 className="w-16 h-16 mx-auto mb-4 text-green-400" />
            <h1 className="text-2xl font-bold mb-3">E-Mail bestätigt!</h1>
            <p className="text-white/80 mb-6">{message}</p>
            <Button
              onClick={() => navigate("/login")}
              data-testid="goto-login-btn"
              className="bg-white text-[#2835F7] hover:bg-gray-100 font-bold w-full"
            >
              Jetzt anmelden
            </Button>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle className="w-16 h-16 mx-auto mb-4 text-red-400" />
            <h1 className="text-2xl font-bold mb-3">Verifizierung fehlgeschlagen</h1>
            <p className="text-white/80 mb-6">{message}</p>
            <Link to="/login">
              <Button data-testid="back-to-login-btn" className="bg-white text-[#2835F7] hover:bg-gray-100 font-bold w-full">
                Zurück zum Login
              </Button>
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
